import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { ActionsDropdown } from 'components/shared/ActionsDropdown/ActionsDropdown'
import { ActionsCell } from 'components/shared/Table/common/Cells/ActionsCell/ActionsCell'
import { HeaderCell } from 'components/shared/Table/common/Cells/HeaderCell/HeaderCell'
import { PrimaryCell } from 'components/shared/Table/common/Cells/PrimaryCell/PrimaryCell'
import { TextCell } from 'components/shared/Table/common/Cells/TextCell/TextCell'
import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { Table } from 'components/shared/Table/Table'
import { FeatureFlag } from 'components/auth/FeatureFlag'
import { getCommaSeparatedText } from 'components/pages/Templates/helpers'
import { toTemplates } from 'ducks/router'
import { getLanguageSymbol } from 'utils/languages'
import { getActions } from './helpers'
import { useJobsTable } from './hooks'

const mapSortingPropToQueryParam = {
  name: 'name',
}

export const JobsTable = ({
  search,
  filter,
  handleCopy,
  handleDelete,
  handleEdit,
}) => {
  const { state, handlers } = useJobsTable({
    mapSortingPropToQueryParam,
    filter,
    search,
  })

  const {
    pagination: { currentPage, pageCount, perPage },
    table: { headers, model, rowActions, isFetching },
  } = state
  const {
    pagination: { handlePage, handlePageSize },
  } = handlers

  return (
    <>
      <Table>
        <Table.Head>
          <Table.Row type="head">
            {R.map(({ columnDef, getToggleSortingHandler, getIsSorted }) => {
              const { accessorKey, header, alignLeft } = columnDef

              return (
                <HeaderCell
                  key={header}
                  alignLeft={!!alignLeft}
                  sortType={getIsSorted()}
                  text={header}
                  onClick={getToggleSortingHandler()}
                  hasSorting={accessorKey}
                />
              )
            }, headers)}
          </Table.Row>
        </Table.Head>
        <Table.Body
          placeholder={{
            title: t`No job templates yet`,
            text: t`Click “+ Job template“ to add`,
          }}
          isLoaded={R.not(isFetching)}
        >
          {R.map(({ id, original }) => {
            const {
              department,
              interview_template,
              languages,
              modules,
              name,
            } = original

            const symbols = R.map(
              key => ({ id: key, name: getLanguageSymbol(key) }),
              languages,
            )
            const actions = getActions(
              { actions: rowActions, template: original },
              { handleCopy, handleDelete, handleEdit },
            )

            return (
              <Table.Row key={id} type="body">
                <PrimaryCell
                  primary={name}
                  to={toTemplates('jobs', id)}
                  hasIncreasedHeight
                />
                <TextCell text={department.name} hasIncreasedHeight />
                <TextCell
                  text={getCommaSeparatedText(symbols)}
                  hasIncreasedHeight
                />
                <TextCell
                  text={modules?.gma ? t`Yes` : '-'}
                  hasIncreasedHeight
                />
                <TextCell
                  text={modules?.personality ? t`Yes` : '-'}
                  hasIncreasedHeight
                />
                <TextCell
                  text={modules?.interview ? interview_template : '-'}
                  hasIncreasedHeight
                />
                <ActionsCell>
                  <FeatureFlag accountAdmin>
                    <ActionsDropdown size="medium" {...{ actions }} />
                  </FeatureFlag>
                </ActionsCell>
              </Table.Row>
            )
          }, model.rows)}
        </Table.Body>
      </Table>
      <Pagination
        onSetPage={handlePage}
        onSetPageSize={handlePageSize}
        {...{ currentPage, pageCount, perPage }}
      />
    </>
  )
}
